import { CSSProperties, FC } from 'react';
import { LinkRenderer } from './LinkRenderer';

interface ICompanyLinkRendererProps {
  website: string | null;
  style?: CSSProperties;
}

export const CompanyLinkRenderer: FC<ICompanyLinkRendererProps> = (params) => {
  const { website, style } = params;
  return <LinkRenderer value={website} style={style} />;
};
